import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'recovery-code-step',
  templateUrl: './recovery-code-step.component.html',
  styleUrls: ['./recovery-code-step.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecoveryCodeStepComponent implements AfterViewInit {
  @ViewChild('recoveryCodeInputElement', { static: true })
  public recoveryCodeInputElement: ElementRef<HTMLInputElement>;

  @Input()
  public isLoading: boolean;

  @Input()
  public recoveryCodeInput: FormControl;

  @Output()
  public insertRecoveryCode: EventEmitter<void>;

  @Output()
  public toSoftwareTokenStep: EventEmitter<void>;

  constructor() {
    this.insertRecoveryCode = new EventEmitter<void>();
    this.toSoftwareTokenStep = new EventEmitter<void>();
  }

  public ngAfterViewInit(): void {
    this.recoveryCodeInputElement.nativeElement.focus();
  }
}
